// extracted by mini-css-extract-plugin
module.exports = {"root":"OrderSummary_root__yVLDU"};